<template>
  <div class="col-sm-12 col-md-6">
    <InputWidget
      v-model="model"
      :error="errors"
      id="input-vat_number"
      :label="computedLabel"
      :placeholder="computedPlaceholder"
      @change="inputChange"
      @input="onInput"
      :rules="required ? 'required' : ''"
    />
  </div>
</template>

<script>
import InputWidget from "../../../core/InputWidget";
import BaseInputMixin from "@/mixins/signupInputMixin";

export default {
  name: "VatNumber",
  components: {InputWidget},
  mixins: [BaseInputMixin('term.vat_number')],

  data() {
    return {
      defaultLabel: this.$t("VAT Number")
    }
  }
}
</script>

<style scoped>

</style>
